(function (w, d) {
  'use strict';

  var boot = d.getElementById('es-header-runtime');
  if (!boot || boot.getAttribute('data-es-booted') === '1') return;
  boot.setAttribute('data-es-booted', '1');

  try {
    var src = boot.getAttribute('data-search-enhance-src') || '';
    if (!src) return;

    var isSearchPage = boot.getAttribute('data-search-page') === '1';
    var loaded = false;
    var loading = false;
    var waitingForJq = false;
    var searchPageRetries = 0;
    var intentSelector = '.js-search-destop, .search-full-destop, .search-full-destop .js_engo_autocomplate';
    var events = ['pointerover', 'touchstart', 'focusin', 'click'];

    function disarmIntent() {
      for (var i = 0; i < events.length; i++) {
        d.removeEventListener(events[i], onIntent, true);
      }
    }

    function finishLoaded(script) {
      loading = false;
      loaded = true;
      if (script) script.setAttribute('data-es-loaded', '1');
      if (!isSearchPage) disarmIntent();
    }

    function failLoaded(script) {
      loading = false;
      loaded = false;
      if (script) {
        script.setAttribute('data-es-load-failed', '1');
        try { script.remove(); } catch (_err) {}
      }
      if (isSearchPage && searchPageRetries < 1) {
        searchPageRetries += 1;
        w.setTimeout(load, 1200);
      }
    }

    function append() {
      waitingForJq = false;
      if (loaded || loading) return;

      var existing = d.querySelector('script[data-es-search-enhance-asset]');
      if (existing && existing.getAttribute('data-es-load-failed') === '1') {
        try { existing.remove(); } catch (_err) {}
        existing = null;
      }
      if (existing) {
        if (existing.getAttribute('data-es-loaded') === '1') {
          finishLoaded(existing);
          return;
        }
        loading = true;
        existing.addEventListener('load', function () { finishLoaded(existing); }, { once: true });
        existing.addEventListener('error', function () { failLoaded(existing); }, { once: true });
        return;
      }

      loading = true;
      var script = d.createElement('script');
      script.src = src;
      script.async = true;
      script.setAttribute('data-es-search-enhance-asset', 'es-search-enhance.js');
      script.onload = function () { finishLoaded(script); };
      script.onerror = function () { failLoaded(script); };
      (d.head || d.documentElement).appendChild(script);
    }

    function load() {
      if (loaded || loading) return;
      if (!w.jQuery) {
        if (!waitingForJq) {
          waitingForJq = true;
          d.addEventListener('es:jQueryReady', append, { once: true });
          w.setTimeout(function () {
            if (w.jQuery) append();
          }, 1600);
        }
        return;
      }
      append();
    }

    function onIntent(event) {
      var target = event && event.target;
      if (!target || !target.closest || !target.closest(intentSelector)) return;
      load();
    }

    if (isSearchPage) {
      if (w.ES_jqReady) w.ES_jqReady(load);
      else load();
      return;
    }

    for (var i = 0; i < events.length; i++) {
      d.addEventListener(events[i], onIntent, true);
    }
  } catch (_err) {}
})(window, document);
